<template>
    <div class="HomeInterativaN2">
        <PageTitle icon="fas fa-user-lock iconInterativoTitulo" main="PLATAFORMA INTERATIVA HION TECNOLOGIA"
            sub="Dashboard Interativo - Perfil Personalizado" />

        <hr class="ml-2 mr-2">
        
    </div>
</template>

<script>
//import VueScrollTo from 'vue-scrollto'
import PageTitle from '../PageTitle'
//import { baseApiUrl, userKey, showError } from '../../../global'
//import axios from 'axios'

export default {
    name: 'HomeInterativaN2',
    components: { PageTitle } ,
    data: function() {
        return {
           
        }
    },
    computed: {
        
    },
    methods: {
        
    },
    mounted() {
        
    }
}
</script>

<style>
    .HomeInterativaN2 {
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>